import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import Home from "./views/home";
import PageLayout from "./layouts/pageLayout";
import MemoriasDaAlma from "./views/memoriasDaAlma";
import MemoriasDaAlmaOcultoHome from "./views/memoriasDaAlma/oculto/home";
import MemoriasDaAlmaOcultoVestigio from "./views/memoriasDaAlma/oculto/vestigio";
import MemoriasDaAlmaOcultoSimbolos from "./views/memoriasDaAlma/oculto/simbolos";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<PageLayout />}>
            <Route index element={<Home />} />
            <Route path="memorias-da-alma" element={<MemoriasDaAlma />}/>
            <Route path="memorias-da-alma/oculto/home" element={<MemoriasDaAlmaOcultoHome />}/>
            <Route path="memorias-da-alma/oculto/vestigio" element={<MemoriasDaAlmaOcultoVestigio />}/>
            <Route path="memorias-da-alma/oculto/simbolos" element={<MemoriasDaAlmaOcultoSimbolos />}/>
            <Route path="*" element={<Navigate to="/" replace />}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
